export const ExpandTooltip = "Show more information";
export const SplitterCollapsed = "Splitter collapsed";
export const SplitterExpanded = "Splitter expanded";
export const SplitterValueText = "Pane width {0} pixels";
